import {create} from "zustand";
import { GetApartmentLookupItemResponseDto } from '@/features/apartments/types/apartments-dto';
import { GetOwnerLookupListItemResponseDto, OwnerListItemResponseDto, OwnerStatus } from '@/features/owners/types/owners-dto';

const DEFAULT_PAGE_SIZE = 10;

type OrdersFilterType = {
    filter: {
        take: number;
        skip?: number;
        apartmentId?: GetApartmentLookupItemResponseDto[];
        ownerId?: GetOwnerLookupListItemResponseDto[];
        ownerStatus?: OwnerStatus | null;
        orderBy?: Capitalize<keyof OwnerListItemResponseDto> | null;
        orderDirection: 'asc' | 'desc';
    },
    setFilter: ( filter: Partial<OrdersFilterType['filter']> ) => void;
    resetFilter: () => void;
};

const defaultState: OrdersFilterType['filter'] = {
    take: DEFAULT_PAGE_SIZE,
    skip: 0, 
    apartmentId: [],
    ownerId: [], 
    ownerStatus: null, 
    orderBy: null, 
    orderDirection: 'asc', 
};

export const useOwnersFilter = create<OrdersFilterType>((set) => ({
    filter: {...defaultState },
    setFilter: (newFilter) => {
        set((state) => ({
            filter: {
                ...state.filter,
                ...newFilter,
            },
        }));
    },
    resetFilter: () => {
        set({ 
            filter: {...defaultState },
        });
    },
}));